import React from 'react'
import PropTypes from 'prop-types'

const AeroplaneIcon = ({ customClassName, width, height, fill, }) =>
  (<svg
    className={customClassName}
    width={width}
    height={height}
    aria-labelledby="Aeroplane"
    viewBox="0 0 32 32"
  >
    <title id="plane-icon">Aeroplane</title>
    <g>
      <path
        fill={fill}
        d="M28,14c-5.724,0-7.514,0-8,0l-6-8h-2l2,8H4l-2-4H0v6l2,2h12l-2,8h2l6-8h8c4,0,4-2,4-2
        C32,14,28,14,28,14z"
      />
    </g>
  </svg>)

AeroplaneIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
  customClassName: PropTypes.string,
}

AeroplaneIcon.defaultProps = {
  width: 20,
  height: undefined,
  fill: 'blue',
  customClassName: '',
}

export default AeroplaneIcon



// WEBPACK FOOTER //
// ./src/components/icons/Aeroplane.js